import React from 'react';

const NestedField = ({ name, value, onChange, editable = true }) => { // Default editable to true

  const handleNestedChange = (nestedName, nestedValue) => {
    const updatedValue = { ...value, [nestedName]: nestedValue };
    onChange(name, updatedValue);
  };

  return (
    <div className="nested-field-group">
      <h4>{name}</h4>
      {Object.entries(value).map(([key, val]) => (
        <div key={key} className="nested-field">
          {typeof val === 'object' && val !== null ? (
            <NestedField
              name={key}
              value={val}
              onChange={(nestedName, nestedValue) =>
                handleNestedChange(key, nestedValue)
              }
              editable={editable} // Pass editable prop recursively
            />
          ) : (
            <div className="form-field">
              <label>{key}</label>
              <input
                type={typeof val === 'number' ? 'number' : 'text'}
                value={val}
                onChange={(e) => {
                  handleNestedChange(key, e.target.value);
                }}
                disabled={!editable} // Disable input if not editable
              />
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default NestedField;
